module.exports = __webpack_public_path__ + "img/case-logo-28.82268b59.png";